var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-user-list"}},[_c('div',{staticClass:"vx-card p-6"},[_c('h1',[_vm._v("กรุณารอสักครู่...")])])])
}]

export { render, staticRenderFns }